import { VStack } from "@chakra-ui/react"
import { DepositForAccount } from "@mezo/api"
import { CHAIN_ID } from "@mezo/sdk"

import {
  DepositActionStatus,
  selectIsOnEthereumChain,
  useDappSelector,
} from "#/redux-state"
import { SDK_NETWORK } from "#/shared/constants"
import FormSubmitButton from "#/ui-old/Buttons/FormSubmitButton"
import SwitchChainButton from "#/ui-old/Buttons/SwitchChainButton"

type DepositMigrationButtonProps = {
  migrationStatus: DepositActionStatus
  selectedDeposit: DepositForAccount | undefined
}

export default function DepositMigrationButton({
  migrationStatus,
  selectedDeposit,
}: DepositMigrationButtonProps) {
  const hasCorrectChain = useDappSelector(selectIsOnEthereumChain)

  const buttonProps = {
    p: "1rem 2rem",
    variant: "primary",
    size: "large",
    gap: 2,
    mb: "20px",
    isDisabled: !selectedDeposit,
  }

  if (!hasCorrectChain)
    return (
      <VStack>
        <SwitchChainButton
          label="migrate"
          chainId={CHAIN_ID[SDK_NETWORK]}
          fontSize="14px"
          lineHeight="20px"
          {...buttonProps}
        />
      </VStack>
    )

  return (
    <FormSubmitButton
      hasError={migrationStatus === "error"}
      isLoading={migrationStatus === "in-progress"}
      buttonProps={{
        w: "13rem",
        ...buttonProps,
      }}
      loaderButtonProps={{ fontSize: "10px", px: 4 }}
      rejectedButtonProps={{ fontSize: "12px" }}
    >
      Migrate
    </FormSubmitButton>
  )
}
